import { render, staticRenderFns } from "./RegistrationFormSH.vue?vue&type=template&id=3a853588"
import script from "./RegistrationFormSH.vue?vue&type=script&lang=js"
export * from "./RegistrationFormSH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports